module.exports = __webpack_public_path__ + "static/media/loopuntil.b12a92c8.svg";